import { useEffect } from 'react'
import { generateScriptElement } from '../html/htmlScripts.hooks'

const RE_CAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/enterprise.js'

export const useReCaptchaScript = (onLoad: () => void) =>
  useEffect(() => {
    const script = generateScriptElement(RE_CAPTCHA_SCRIPT_SRC, onLoad)

    document.body.appendChild(script)

    return () => {
      // If script is in the dom, we remove it
      if (script.parentElement) {
        document.body.removeChild(script)
      }
    }
  }, [onLoad])
